import { generatePath } from "react-router";

import { PageMeta } from "@/lib/react-helmet-async";

import { PATHS } from "@/routes/paths";

import { HotelNotificationSettingsContainer } from "@/components/features/hotel-notification-settings/ui";

import { useConfirmParams } from "./hooks";

export const HotelSettingsEmailPage = () => {
	const result = useConfirmParams();

	const { canRender } = result;
	if (!canRender) return <></>;

	const { hotelID } = result;

	return (
		<PageMeta title="通知の設定" url={generatePath(PATHS.HOTEL.HOTEL_SETTINGS.EMAIL, { hotelID })}>
			<HotelNotificationSettingsContainer hotelID={hotelID} />
		</PageMeta>
	);
};

HotelSettingsEmailPage.displayName = "HotelSettingsEmailPage";
